import { BuildProps } from '@app/origami-api/build-props';

export class OrigamiUrls {
  static get tiJsFile() {
    return `../ti/js/ti.js`;
  }
  static get settingsScript() {
    return `${BuildProps.origin}GetSettingsScript.aspx`;
  }
  static get settingsPage() {
    return `../ti/settings.html?siteId={roomId}`;
  }
  static get domainSettings() {
    return `../ti/index.html#menu/settings`;
  }
  static get recordTypesSettingsPage() {
    return `../ti/settings.html?siteId={roomId}#record-types?embedded=true`;
  }
  static get domainTasks() {
    return `../ti/index.html#tasks`;
  }
  static get userProfile() {
    return `../ti/index.html#menu/user-profile`;
  }
  static get addRoom() {
    return `../ti/index.html#datarooms/rooms?mode=add`;
  }
  static get enterRoom() {
    return `../ti/index.html#`;
  }
  static get userLookup() {
    return `../ti/index.html#menu/userlookup`;
  }
  static get dataroomsManagement() {
    return `../ti/index.html#datarooms`;
  }
  static get crossStudyReports() {
    return `../ti/index.html#reports`;
  }
  static get documentsSearch() {
    return `../ti/index.html#documents/documents?query= `;
  }
  static get maintenanceScheduledPage() {
    return `${BuildProps.origin}Maintenance/ScheduledMaintenance.html`;
  }
  static get maintenanceInProgressPage() {
    return `${BuildProps.origin}Maintenance/ActiveMaintenance.html`;
  }
  static get homePage() {
    return `../ti/index.html#home/dashboard`;
  }
  static get temporaryLogin() {
    return `../ti/index.html?temporaryLogin`;
  }
  static get documentViewerPattern() {
    return `../ti/mini.html#viewer/{roomId}/{topicId}`;
  }
  static get goToDocumentPattern() {
    return `../ti/index.html#{roomId}/etmf/documents?documentid={topicId}&mode=full`;
  }
  static get goToRegReviewPattern() {
    return `../ti/index.html#{roomId}/startup/regreview?mode=full&documentid={topicId}&v=15&n=1`;
  }
  static get goToFolderPattern() {
    return `../ti/index.html#{roomId}/etmf/documents?v=0&n={hierarchy}`;
  }
  static get bulkInviteTemplate() {
    return `${BuildProps.origin}ConfigService.svc/GetPublicResource?siteId={roomId}&ResourceName=Templates/BulkInviteUsersTemplate.xlsx`;
  }
  static get aboutThisRoomTemplate() {
    return `${BuildProps.origin}{serviceName}/GetPublicResource?siteId={siteId}&localeName={localeName}&ResourceName=Welcome/{shortName}/welcome.html`;
  }
  static get fileUploadTemplate() {
    return `${BuildProps.origin}FileUploadService.svc/UploadFile?siteId={siteId}`;
  }
  static get documentsImportTemplate() {
    return `${BuildProps.origin}ConfigService.svc/GetPublicResource?siteId={roomId}&ResourceName=Templates/DocumentsImportTemplate.xlsx`;
  }

  static get cwsDocumentsImportTemplate() {
    return `${BuildProps.origin}ConfigService.svc/GetPublicResource?siteId={roomId}&ResourceName=Templates/CWSDocumentsImportTemplate.xlsx`;
  }

  static get recordTypesImportTemplate() {
    return `${BuildProps.origin}ConfigService.svc/GetPublicResource?siteId={roomId}&ResourceName=Templates/RecordTypesImportTemplate.xlsx`;
  }

  static get sitesImportTemplate() {
    return `${BuildProps.origin}ConfigService.svc/GetPublicResource?siteId={roomId}&ResourceName=Templates/SitesImportTemplate.xlsx`;
  }
  static get openTopicFileWithUrl() {
    return `${BuildProps.origin}{serviceName}/GetTopicFileWithUrl/{siteId}/{TopicId}/{attachmentId}/0/OpenFile/false`;
  }
  static get saveTopicFileWithUrl() {
    return `${BuildProps.origin}{serviceName}/GetTopicFileWithUrl/{siteId}/{TopicId}/{attachmentId}/0/SaveFile/true`;
  }
  static get izendaReportUrlTemplate() {
    return `Reports/{siteId}/ReportViewer.aspx?rn={dashboardCategory}\\\\{dashboardName}`;
  }
  static get izendaReportUrlIframe() {
    return `${BuildProps.origin}/switchhost.aspx?host=report&redirect={reportUrl}`;
  }
  static get imageUploadUrl() {
    return `${BuildProps.origin}SiteService.svc/AddSiteFile?siteId={siteId}&withAuthKey=true`;
  }
  static get imageManagerLoadURL() {
    return `${BuildProps.origin}SiteService.svc/GetSiteFiles2`;
  }
  static get deleteSiteFileURL() {
    return `${BuildProps.origin}SiteService.svc/DeleteSiteFile`;
  }
  static get getSiteFilesURL() {
    return `${BuildProps.origin}SiteService.svc/GetSiteFiles`;
  }
  static get translationWindowUrlTemplate() {
    return `${BuildProps.origin}Translation/FullTextTranslation.aspx?siteId={siteId}&topicId={topicId}&originalname={originalname}`;
  }
}
